import React from 'react';

const BoltFillSvg = (props) => (
    <svg
        className="bolt-fill_svg__eds-icon--bolt-fill_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="bolt-fill_svg__eds-icon--bolt-fill_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 2L5 15h7v7l7-13h-7z"
        />
    </svg>
);

BoltFillSvg.displayName = 'BoltFillSvg';
export default BoltFillSvg;
